import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import ReactGA from 'react-ga4';

import { Layout } from './components/layout/Layout';
import Home from './pages/Home';
import Services from './pages/Services';
import Work from './pages/Work';
import About from './pages/About';
import Contact from './pages/Contact';
import './App.css';
import MusicVideoProduction from "./pages/MusicVideoProductionGuwahati";
import MusicVideoCostGuwahati from "./pages/MusicVideoCostGuwahati";
import MusicVideoProcessGuwahati from "./pages/MusicVideoProcessGuwahati";
import RapMusicVideoProductionGuwahati from "./pages/RapMusicVideoProductionGuwahati";
import MusicVideoProductionAssam from "./pages/MusicVideoProductionAssam";
import MusicVideoProductionNortheast from "./pages/MusicVideoProductionNortheast";
import HowToPlanMusicVideoShoot from "./pages/HowToPlanMusicVideoShoot";


// 🔥 Analytics Tracker Component
function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    ReactGA.initialize("G-ZPVEJ06LYD");
  }, []);

  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: location.pathname + location.search
    });
  }, [location]);

  return null;
}

function App() {
  return (
    <BrowserRouter>
      <AnalyticsTracker />
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/work" element={<Work />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/music-video-production-guwahati" element={<MusicVideoProduction />} />
          <Route path="/music-video-production-cost-guwahati" element={<MusicVideoCostGuwahati />} />
          <Route path="/music-video-production-process-guwahati" element={<MusicVideoProcessGuwahati />} />
          <Route path="/rap-music-video-production-guwahati" element={<RapMusicVideoProductionGuwahati />} />
          <Route path="/music-video-production-assam" element={<MusicVideoProductionAssam />} />
          <Route path="/music-video-production-northeast" element={<MusicVideoProductionNortheast />} />
          <Route path="/how-to-plan-music-video-shoot" element={<HowToPlanMusicVideoShoot />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;